export default function CallOutsPanel({ item, blockId, index }) {
  if (!item) return null;
  return (
    <div className={'CallOuts-item'}>
      {item.heading && (
        <p className={'CallOuts-iconHeading headingStrong'}>{item.heading}</p>
      )}
      {item.description && (
        <p
          className={'CallOuts-iconDescription'}
          dangerouslySetInnerHTML={{ __html: item.description }}
        ></p>
      )}
    </div>
  );
}
